import { useMemo, useEffect } from 'react';
import { nanoid as generate } from 'nanoid';
import { getTableState, clearTableState } from '../utils';

/**
 * Custom hook to manage FlexTable state and lifecycle
 * Handles table ID generation, state management, page break calculation,
 * and cleanup on unmount
 *
 * @returns Object containing tableId and tableState
 */
const useFlexTable = () => {
  // Generate a unique table ID for this instance and get table-specific state from module-level store
  // This ensures each FlexTable instance maintains its own state to avoid conflicts
  const tableId = useMemo(() => generate(), []);
  const tableState = getTableState(tableId);

  // Cleanup table state on unmount
  useEffect(() => {
    return () => {
      clearTableState(tableId);
    };
  }, [tableId]);

  return {
    tableId,
    tableState
  };
};

export default useFlexTable;
